import { SportSearchInput } from "../../types/sport/SportSearchInput";
import { SportAssociationNumberOf } from "../../types/SportAssociation";

export const fetchSportsByClub = async (
  backendUrl: string,
  sportAssociation: string,
  body: SportSearchInput,
): Promise<string[]> => {
  return fetchSports(backendUrl, "by-club", sportAssociation, body);
};

export const fetchSportsByTargetGroup = async (
  backendUrl: string,
  sportAssociation: string,
  body: SportSearchInput,
): Promise<string[]> => {
  return fetchSports(backendUrl, "by-training-group", sportAssociation, body);
};

const fetchSports = async (
  backendUrl: string,
  target: "by-club" | "by-training-group",
  sportAssociation: string,
  body: SportSearchInput,
): Promise<string[]> => {
  const urlParams = [];
  if (body?.postalCode) {
    urlParams.push("postalCode=" + encodeURIComponent(body.postalCode));
  }
  if (body?.perimeter) {
    urlParams.push("perimeter=" + encodeURIComponent(body.perimeter));
  }
  const urlParamsString = urlParams.length > 0 ? "?" + urlParams.join("&") : "";
  try {
    const response = await fetch(
      backendUrl + "/sport/" + target + urlParamsString,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Sport-Association": SportAssociationNumberOf(sportAssociation),
        },
      },
    );
    return await response.json();
  } catch (err) {
    console.log(err);
  }
  return [];
};
